// extracted by mini-css-extract-plugin
var _1 = "iYRgh";
var _2 = "U0L0P";
var _3 = "KtOg5";
var _4 = "UA9z2";
export { _1 as "is-disabled", _2 as "is-inherit", _3 as "is-inverse", _4 as "link" }
